/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function SessionIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="78.5"
        cy="78.5"
        r="77.5"
        fill={mainColor}
        stroke="white"
        stroke-width="2"
      />
      <path
        d="M48.52 103.64H59.4L56.68 112.14C55.66 115.2 58.04 118.6 61.44 118.6C63.48 118.6 65.52 117.24 66.2 115.2L69.94 103.64H86.26L90 115.2C90.68 117.24 92.72 118.6 94.76 118.6C98.16 118.6 100.54 115.2 99.52 112.14L96.8 103.64H108.36C113.46 103.64 117.88 99.22 117.88 94.12V56.38C117.88 51.28 113.46 46.86 108.36 46.86H88.64C88.64 41.42 84.22 37 78.78 37C73.34 37 68.92 41.42 68.92 46.86H48.52C43.42 46.86 39 51.28 39 56.38V94.12C39 99.56 43.42 103.64 48.52 103.64ZM56.68 79.84L69.6 66.24C70.28 65.56 71.3 65.22 72.32 65.22C73.34 65.22 74.36 65.9 74.7 66.58L82.86 77.12L94.76 66.24C96.12 64.88 98.16 64.88 99.52 66.58C100.88 67.94 100.88 69.98 99.18 71.34L84.56 84.94C83.88 85.62 83.2 85.96 82.18 85.96H81.84C80.82 85.96 80.14 85.28 79.46 84.6L71.64 74.06L61.44 84.6C60.08 85.96 58.04 85.96 56.68 84.6C55.66 83.58 55.32 81.2 56.68 79.84Z"
        fill={secondaryColor}
      />
    </svg>
  );
}
SessionIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
SessionIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(SessionIcon);
memoized.displayName = 'SessionIcon';
export default memoized;
